import script from "./ChatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatModal.vue?vue&type=style&index=0&id=87a28454&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87a28454"]])

export default __exports__